var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderAscendingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 5,
    viewBox: "0 0 12 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38103 5C0.913377 5 0.701676 4.41527 1.06093 4.11589L5.67991 0.266744C5.86533 0.112224 6.13467 0.112224 6.32009 0.266743L10.9391 4.11589C11.2983 4.41527 11.0866 5 10.619 5H6L1.38103 5Z",
    fill: "#148BCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderAscendingActive);
export default __webpack_public_path__ + "static/media/order_ascending_active.c32c7dbf552b4e9b0025b76c4a805c72.svg";
export { ForwardRef as ReactComponent };